export default __webpack_public_path__ + "static/media/companyimg4.28d2ca1a.jpeg";